import React, { createRef, useState } from "react";
import { Col, Row, Spinner, UncontrolledTooltip } from "reactstrap";
import { getExtentionFile, isImageFile } from "../helpers/utility";
import Dropzone from "react-dropzone";
import { REASONS } from "../constants/reason";
import { FileUploadValidator } from "../helpers/file-upload-validator";
import ApiRequest from "../helpers/api_server";
import DropDownAlert from "./DropDownAlert";
import { compressFile } from "../helpers/compress";

function UploadFile({
    id,
    disableEdit,
    typeFile,
    file,
    titleDocument,
    showPreviewImage,
    loanId = "",
    customerId = "",
    getDocumentFile = () => {}
}) {
    const [processUpload, setProcessUpload] = useState(null);
    const dropzoneRef = createRef();
    const openDialog = () => {
        if (dropzoneRef.current) {
            dropzoneRef.current.open();
        }
    };

    const FileIcon = ({ file }) => {
        if (!file) {
            return <i className="uil-folder-upload font-size-20" />;
        }

        return isImageFile(file) ? (
            <i className="uil-scenery font-size-20" />
        ) : (
            <i className="uil-file-alt font-size-20" />
        );
    };

    async function handleAcceptedFiles(files, key) {
    try {
      setProcessUpload(key);

        const maxSize = 0.8 * 1024 * 1024; // 0.8 MB limit
        const fileSize = files[0].size;

      if (files[0].type.indexOf("image") > -1) {
        if (fileSize > maxSize) {
          const compressedFile = await compressFile(files[0]);
          const newFile = new File([compressedFile], compressedFile.name, {
            type: compressedFile.type,
          });
          files[0] = newFile;
        }
      }

      const validator = new FileUploadValidator({ files: files, key: key });

      if (!validator.valid) throw new Error(validator.messages);

      let formData = new FormData();
      formData.append("file", files[0]);
      formData.append("customer_id", customerId);
      formData.append("key", key);
      formData.append("file_type", files[0].type);
      formData.append("loan_id", loanId);

      try {
        await ApiRequest.post("/customer/upload", formData, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        });
        getDocumentFile();
        DropDownAlert.show("success", "Dokumen berhasil diunggah");
        return "SUCCESS"
      } catch (error) {
        DropDownAlert.show("danger", error.message);
        return "FAILED"
      }
    } catch (error) {
      const messages = error.message.split(",");
      for (const message of messages) {
        DropDownAlert.show("warning", message);
      }
      return "FAILED"
    } finally {
      setProcessUpload(null);
    }
  }


    return (
        <Dropzone
            ref={dropzoneRef}
            noClick
            noKeyboard
            onDrop={(acceptedFiles) => handleAcceptedFiles(acceptedFiles, typeFile)}
        >
            {({ getRootProps, getInputProps }) => (
                <div
                    {...getRootProps({ className: "dropzone" })}
                    style={{ backgroundColor: disableEdit ? "#f4f4f4" : "#ffffff" }}
                    id={id}
                >
                    <input
                        {...getInputProps()}
                        id={titleDocument.toLowerCase().split(" ").join("-").replace(/[/()]/g, "")}
                    />
                    <div className="p-1 px-2">
                        <Row className="align-items-center">
                            <Col className="col-auto">
                                <div className="avatar-sm font-weight-bold">
                                    <span className="avatar-title rounded bg-soft-primary text-primary">
                                        <FileIcon file={file} />
                                    </span>
                                </div>
                            </Col>
                            <Col className="pl-0">
                                <span className="text-muted font-weight-bold">{titleDocument}</span>
                                <p className="mb-0">
                                    format file: {file ? getExtentionFile(file) : "-"}
                                </p>
                                {(typeFile == "ktp" ||
                                    typeFile == "selfie_ktp" ||
                                    typeFile === "ro_ktp" ||
                                    typeFile == "ro_selfie_ktp") && (
                                    <>
                                        <ul className="m-0 pl-3">
                                            <li>
                                                <small className="mb-0">{`Format foto harus berupa JPG/JPEG`}</small>
                                            </li>
                                            <li>
                                                <small className="mb-0">{`Ukuran maksimal foto 1 MB`}</small>
                                            </li>
                                        </ul>
                                    </>
                                )}
                              {(typeFile == "coe" ||
                                    typeFile == "selfie_contract_document" ||
                                    typeFile == "employment_contract_document" ||
                                    typeFile == "ro_membership_application_document" ||
                                    typeFile == "ro_employment_contract_document") && (
                                    <ul className="m-0 pl-3">
                                    <li>
                                        <small className="mb-0">{`Format dokumen harus berupa PDF`}</small>
                                    </li>
                                    </ul>
                                )}

                                {(typeFile === REASONS.PARENTAL_FORM) && (
                                    <ul className="m-0 pl-3">
                                    <li>
                                        <small className="mb-0">{`Format dokumen harus berupa PDF/JPG/PNG`}</small>
                                    </li>
                                    </ul>
                                )}

                                
                            </Col>
                            <Col className="col-auto row d-flex justify-content-end mr-1">
                                {processUpload === typeFile && (
                                    <Spinner color={"#369378"} size="sm" className="mr-2" />
                                )}
                                {file && !processUpload && isImageFile(file) && (
                                    <div>
                                        <a
                                            className="btn btn-link text-primary btn-lg p-0 ml-1"
                                            id={`btn-d-${id}`}
                                            onClick={showPreviewImage}
                                        >
                                            <i className="uil uil-eye font-size-20"></i>
                                        </a>
                                        <UncontrolledTooltip
                                            placement="bottom"
                                            target={`btn-d-${id}`}
                                        >
                                            Lihat Dokumen
                                        </UncontrolledTooltip>
                                    </div>
                                )}
                                {file && !processUpload && !isImageFile(file) && (
                                    <div>
                                        <a
                                            href={file}
                                            target="_blank"
                                            className="btn btn-link text-primary btn-lg p-0 ml-1"
                                            id={`btn-d-${id}`}
                                        >
                                            <i className="uil uil-eye font-size-20"></i>
                                        </a>
                                        <UncontrolledTooltip
                                            placement="bottom"
                                            target={`btn-d-${id}`}
                                        >
                                            Lihat Dokumen
                                        </UncontrolledTooltip>
                                    </div>
                                )}
                                {!processUpload && !disableEdit && (
                                    <div>
                                        <a
                                            id={`btn-dl-${id}`}
                                            className="btn btn-link text-primary btn-lg p-0 ml-1"
                                            onClick={openDialog}
                                        >
                                            <i className="uil uil-upload-alt font-size-20"></i>
                                        </a>
                                        <UncontrolledTooltip
                                            placement="bottom"
                                            target={`btn-dl-${id}`}
                                        >
                                            Unggah Dokumen
                                        </UncontrolledTooltip>
                                    </div>
                                )}
                            </Col>
                        </Row>
                    </div>
                </div>
            )}
        </Dropzone>
    );
}

export default UploadFile;
